import React from 'react'
import ExpandLessRounded from '@mui/icons-material/ExpandLessRounded'
import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded'
import { timelineLabel } from '../constants'

export default function QuestStage({
  stage,
  timelineUnit,
  progress,
  onToggleCollapse,
  onJump,
}) {
  const unit = timelineLabel[timelineUnit] || '阶段'
  const title = stage.title || (stage.no ? `第${stage.no}${unit}` : (Number(stage.no) === 0 ? '未分组' : '其它资源'))
  const canCollapse = stage.itemCount > 1
  const band = stage.band
  const done = progress?.done || 0
  const total = progress?.total || stage.itemCount || 0

  return (
    <div
      className={`quest-stage-banner${stage.collapsed ? ' is-collapsed' : ''}`}
      style={{
        left: stage.labelLeft ?? 10,
        top: band?.top ?? stage.bannerTop ?? 0,
      }}
    >
      <button
        type="button"
        className="quest-stage-jump"
        onClick={() => onJump?.(stage)}
        aria-label={`定位到${title}，已完成 ${done}/${total}`}
      >
        <span className="quest-stage-badge">{stage.no || stage.stageIndex + 1}</span>
        <span className="quest-stage-copy">
          <span className="quest-stage-title">{title}</span>
          <span className="quest-stage-progress">{done}/{total}</span>
        </span>
      </button>
      {canCollapse ? (
        <button
          type="button"
          className="quest-stage-toggle"
          onClick={(e) => {
            e.stopPropagation()
            onToggleCollapse?.(stage.stageKey)
          }}
          aria-label={stage.collapsed ? '展开阶段' : '折叠阶段'}
        >
          {stage.collapsed
            ? <ExpandMoreRounded fontSize="small" />
            : <ExpandLessRounded fontSize="small" />}
        </button>
      ) : null}
    </div>
  )
}
